import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { useLocale } from '@/lib/hooks/use-locale';
import type { CrmNoteType } from '@prisma/client';
import { CalendarIcon, NotepadTextIcon, PhoneIcon } from 'lucide-react';
import React from 'react';

export interface NoteTypeSelectorProps {
    value: CrmNoteType;
    onChange: (value: CrmNoteType) => void;
}

interface NoteTypeOption {
    value: CrmNoteType;
    translationKey: string;
    icon: React.ComponentType<{ className?: string }>;
}

const noteTypeOptions: NoteTypeOption[] = [
    {
        value: 'EVENT',
        translationKey: 'notes__type__event',
        icon: CalendarIcon,
    },
    {
        value: 'PHONE_CALL',
        translationKey: 'notes__type__phone_call',
        icon: PhoneIcon,
    },
    {
        value: 'NOTE',
        translationKey: 'notes__type__note',
        icon: NotepadTextIcon,
    },
];

export const NoteTypeSelector = ({ value, onChange }: NoteTypeSelectorProps) => {
    const { t } = useLocale();

    const handleValueChange = (value: string) => {
        onChange(value as CrmNoteType);
    };

    return (
        <RadioGroup value={value} onValueChange={handleValueChange}>
            {noteTypeOptions.map((option) => {
                return (
                    <RadioGroupItem
                        id="option-one"
                        value={option.value}
                        key={option.value}
                        icon={option.icon}
                    >
                        {t(option.translationKey, { ns: 'notes' })}
                    </RadioGroupItem>
                );
            })}
        </RadioGroup>
    );
};
